import { forwardRef } from "react";

import { DatePicker } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormDatePickerProps } from "../../types";

export const FormDatePicker = forwardRef<HTMLInputElement, FormDatePickerProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <DatePicker ref={ref} name={name} {...props} />
  </FormField>
));

FormDatePicker.displayName = "Form.DatePicker";
